import { render, staticRenderFns } from "./SectionPreviewSkill.vue?vue&type=template&id=00ca41e2&"
import script from "./SectionPreviewSkill.vue?vue&type=script&lang=ts&"
export * from "./SectionPreviewSkill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports